import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { RemoveVersionPipe } from '../remove-version.pipe';

export interface CardData {
  image: string;
  imageHover: string;
  hasHover: boolean;
  title: string;
  subtitle: string;
  modal: object[];
}

export interface SectionCardSaudeData {
  title: string;
  subtitle: string;
  cards: Array<CardData>;
}

@Component({
  selector: 'fcp-section-card-saude',
  templateUrl: './section-card-saude.component.html',
  styleUrls: ['./section-card-saude.component.scss']
})
export class SectionCardSaudeComponent implements OnInit {
  @Input() public sectionCardSaude: SectionCardSaudeData;
  @Output() public clicked: EventEmitter<any> = new EventEmitter();

  constructor(private removeVersion: RemoveVersionPipe) {}

  ngOnInit(): void {}

  public wasClicked(modal): void {
    if (modal && modal.length > 0) {
      this.clicked.emit(modal);
    }
  }

  public setImage(elem: HTMLDivElement, url): void {
    if (elem) {
      elem['src'] = this.removeVersionImage(url);
    }
  }

  private removeVersionImage(value: string): string {
    return this.removeVersion.transform(value);
  }
}
